module.exports = __webpack_public_path__ + "static/media/instagram.681f6026.svg";